import {useState,useEffect} from 'react'

export const useFetchOnlineStatus = () => {
    const [onlineStatus, setOnlineStatus]= useState(true)

    useEffect(()=>{
     window.addEventListener('offline', ()=>{
        setOnlineStatus(false)
     })
     
    window.addEventListener('online', ()=>{
            setOnlineStatus(true)

     })
     
    },[])
    

  return onlineStatus
    
  

}
